// Mock data for ScoutOS / Playfolio clone
// NOTE: This data is mocked for the frontend-only phase.

export const stats = {
  players: 6,
  academies: 0,
  scouts: 0,
};

export const positions = [
  "Goalkeeper",
  "Centre Back",
  "Full Back",
  "Defensive Midfielder",
  "Central Midfielder",
  "Attacking Midfielder",
  "Left Winger",
  "Right Winger",
  "Striker",
];

export const countries = [
  "Portugal",
  "Spain",
  "Greece",
  "England",
  "Germany",
  "France",
  "Italy",
  "Serbia",
  "Netherlands",
];

export const players = [
  {
    id: "6a48abe795d0a2579b66a0c8",
    name: "Marco Silva",
    initial: "M",
    position: "Striker",
    age: 18,
    birthYear: 2008,
    city: "Lisbon",
    country: "Portugal",
    height: 180,
    foot: "Left",
    views: 257,
    club: "Benfica Academy",
    openForTrial: false,
    bio: "Clinical striker with excellent movement in the box and a lethal left foot. Product of the Benfica youth setup.",
    videos: [
      { title: "Season Highlights 2024/25", youtubeId: "IZiAaFDViGw" },
      { title: "Full Match vs Porto U19", youtubeId: "3nZ7lVJfSj0" },
    ],
    stats: { appearances: 24, goals: 19, assists: 6, minutes: 1980 },
  },
  {
    id: "6a48abe795d0a2579b66a0cb",
    name: "Lucas García",
    initial: "L",
    position: "Attacking Midfielder",
    age: 15,
    birthYear: 2011,
    city: "Barcelona",
    country: "Spain",
    height: 162,
    foot: "Left",
    views: 67,
    club: "RCD Espanyol Youth",
    openForTrial: true,
    bio: "Creative number 10 with superb vision, tight ball control and the ability to unlock defenses with a single pass.",
    videos: [
      { title: "Skills & Assists Compilation", youtubeId: "l3B0Ez3z6Yo" },
    ],
    stats: { appearances: 20, goals: 8, assists: 14, minutes: 1520 },
  },
  {
    id: "6a48abe795d0a2579b66a0ca",
    name: "D. Karagiannis",
    initial: "D",
    position: "Centre Back",
    age: 19,
    birthYear: 2007,
    city: "Thessaloniki",
    country: "Greece",
    height: 185,
    foot: "Right",
    views: 198,
    club: "PAOK Academy",
    openForTrial: true,
    bio: "Commanding centre back, strong in the air and composed on the ball. Natural leader at the back.",
    videos: [
      { title: "Defensive Highlights", youtubeId: "9zNkfCJQYNA" },
    ],
    stats: { appearances: 26, goals: 3, assists: 1, minutes: 2340 },
  },
  {
    id: "6a48abe795d0a2579b66a0cc",
    name: "James Carter",
    initial: "J",
    position: "Goalkeeper",
    age: 18,
    birthYear: 2008,
    city: "London",
    country: "England",
    height: 178,
    foot: "Right",
    views: 112,
    club: "Crystal Palace Academy",
    openForTrial: false,
    bio: "Agile shot-stopper with quick reflexes and excellent distribution. Comfortable playing out from the back.",
    videos: [
      { title: "Best Saves 2024/25", youtubeId: "kTaBUiPZfhs" },
    ],
    stats: { appearances: 22, goals: 0, assists: 0, minutes: 1980, cleanSheets: 11 },
  },
  {
    id: "6a48abe795d0a2579b66a0c7",
    name: "Nikos Papadopoulos",
    initial: "N",
    position: "Central Midfielder",
    age: 17,
    birthYear: 2009,
    city: "Athens",
    country: "Greece",
    height: 175,
    foot: "Right",
    views: 142,
    club: "AEK Athens Academy",
    openForTrial: true,
    bio: "Box-to-box midfielder with a high work rate, great stamina and an eye for a long-range strike.",
    videos: [
      { title: "Midfield Masterclass", youtubeId: "6vHfSbBXOKw" },
    ],
    stats: { appearances: 23, goals: 6, assists: 9, minutes: 2010 },
  },
  {
    id: "6a48abe795d0a2579b66a0c9",
    name: "Alex Müller",
    initial: "A",
    position: "Left Winger",
    age: 16,
    birthYear: 2010,
    city: "Munich",
    country: "Germany",
    height: 168,
    foot: "Both",
    views: 90,
    club: "TSV 1860 Munich Youth",
    openForTrial: true,
    bio: "Explosive winger with electric pace, direct dribbling and the ability to play on either flank.",
    videos: [
      { title: "Dribbling & Speed Reel", youtubeId: "Zi_XLOBDo_Y" },
    ],
    stats: { appearances: 21, goals: 11, assists: 8, minutes: 1680 },
  },
];

export const plans = [
  {
    id: "basic",
    name: "Basic Scout",
    price: 29,
    popular: false,
    premium: false,
    features: [
      { label: "Limited search filters", included: true },
      { label: "50 player views / month", included: true },
      { label: "10 watchlist spots", included: true },
      { label: "View YouTube videos", included: true },
      { label: "Private notes", included: true },
      { label: "Contact requests", included: false },
      { label: "Advanced filters", included: false },
      { label: "Export reports", included: false },
    ],
  },
  {
    id: "pro",
    name: "Pro Scout",
    price: 79,
    popular: true,
    premium: false,
    features: [
      { label: "Full search & filters", included: true },
      { label: "Unlimited player views", included: true },
      { label: "Unlimited watchlist", included: true },
      { label: "View YouTube videos", included: true },
      { label: "Private notes", included: true },
      { label: "Contact requests", included: true },
      { label: "Advanced filters", included: true },
      { label: "Export reports", included: false },
    ],
  },
  {
    id: "club",
    name: "Club / Agency",
    price: 149,
    popular: false,
    premium: false,
    features: [
      { label: "Everything in Pro", included: true },
      { label: "Multiple users", included: true },
      { label: "Team dashboard", included: true },
      { label: "Shared watchlists", included: true },
      { label: "Advanced filters", included: true },
      { label: "Export reports", included: true },
      { label: "Priority support", included: true },
      { label: "API access", included: true },
    ],
  },
  {
    id: "college",
    name: "College / International",
    price: 199,
    popular: false,
    premium: true,
    features: [
      { label: "Everything in Club", included: true },
      { label: "College-specific filters", included: true },
      { label: "Academic data fields", included: true },
      { label: "International search", included: true },
      { label: "Priority access", included: true },
      { label: "Export reports", included: true },
      { label: "Dedicated support", included: true },
      { label: "Custom integrations", included: true },
    ],
  },
];
